import { useMutation } from 'react-query';

import { exportProjectDataAsFile as mutationFn } from 'api/endPoints/exportProjectDataAsFile';

export const useMutationExportXerOrMpp = () => {
    return useMutation<unknown, QueryError, QueryParams>({
        mutationFn: (params) => mutationFn(params),
    });
};

interface QueryParams {
    metaDataId: number;
    exportType: string;
    fileName?: string;
}
